<template>
    <v-row class="mx-4" align="center">
        <v-avatar class="d-inline-block" size="64">
            <v-icon dark x-large color="ddgrey">mdi-account-circle</v-icon>
        </v-avatar>
        <span>
            <span class="d-block">
                <v-chip v-if="user.isAdmin" x-small color="green" class="mr-2 px-2">{{ !isMobile ? 'Admin' : '' }}</v-chip>
                {{ user.name }}
            </span>
            <span v-if="!isMobile" class="d-block ddgrey--text text-body-2">{{ user.email }}</span>
        </span>
    </v-row>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import EventBus from '@/utils/EventBus';

/**
 * UserAccount component shows the current user information in a single component,
 * such as the user name, the email and if the user has the administrator role.
 */
export default {
    name: 'UserAccount',
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        user: {},
        error: false
    }),
    async mounted() {
        await this.updateUser();
        EventBus.$on("userUpdated", async () => {
            await this.updateUser();
        });
    },
    methods: {
        async updateUser() {
            const [ success, user ] = await AuthAPI.currentUser();
            if (success) {
                this.user = user.attributes;
                this.user.isAdmin = user.isAdmin;
            } else this.$router.push({ name: 'login' });
        }
    },
    watch: {
        user(newValue) {
            const keys = Object.keys(newValue);
            if (!keys.includes("name") || !keys.includes("email")) this.updateUser();
        }
    }
}
</script>
